module.exports = __webpack_public_path__ + "media/images/home_bg-1aedcc30b49e67b4d9b95af1ef3caae8.jpg";